export default __webpack_public_path__ + "static/media/logo.6d503a67.png";